import { getEula } from '@connect-x-app/hybrid-data-access';
import { ApiError, Eula, QueryKeys } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

export const useGetEula = () =>
  useQuery<Eula, ApiError>({
    queryFn: getEula,
    queryKey: [QueryKeys.EULA],
    select: data => {
      return {
        ...data,
        eulaText: data.eulaText.replace(/\\n/gi, '\n'),
      };
    },
  });
